module.exports = __webpack_public_path__ + "img/elinxmas310x588.211db5ce.jpg";